import {
  normalizeWorkspaceSlug,
  setActiveWorkspaceDatabase,
  writeActiveCompanySession,
  ensureTabWorkspaceDatabasePinned,
  getActiveWorkspaceSlug,
} from "./workspaceStorage";
import {
  readTabAuthWorkspaceSlug,
  readTabBearerToken,
  readTabUserData,
  clearTabAuthStorage,
} from "./tabAuthStorage";
import { readJwtScope, readJwtCompanyClaim } from "../api/clientJwt";

/**
 * Ativa o workspace a partir de ?ws= ou ?company= na URL (nova aba / popup-call).
 * Retorna o slug aplicado ou null.
 *
 * Se a aba já tem JWT workspace de outro tenant, limpa auth (não reusa Bearer).
 */
export function bootstrapWorkspaceFromUrl(search = "") {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(search || window.location.search || "");
  const ws = normalizeWorkspaceSlug(
    params.get("ws") || params.get("company") || params.get("c")
  );
  if (!ws) {
    // Sem ?ws=/?c=: congela nesta aba o schema já presente (evita herdar troca feita em outra aba).
    ensureTabWorkspaceDatabasePinned();
    return null;
  }

  try {
    const token = readTabBearerToken();
    if (token) {
      const scope = readJwtScope(token);
      const ud = readTabUserData();
      const effectiveScope = ud?.scope || scope || "workspace";
      if (effectiveScope === "workspace" || !ud?.scope) {
        const bound =
          normalizeWorkspaceSlug(readJwtCompanyClaim(token)) ||
          normalizeWorkspaceSlug(readTabAuthWorkspaceSlug()) ||
          normalizeWorkspaceSlug(ud?.company);
        if (bound && bound !== ws) {
          clearTabAuthStorage();
        }
      }
    }
  } catch {
    /* ignore */
  }

  try {
    setActiveWorkspaceDatabase(ws);
    writeActiveCompanySession(ws, ws);
  } catch {
    /* ignore */
  }
  return ws;
}

/**
 * Anexa ?ws=slug a um path interno.
 */
export function appendWorkspaceQuery(path, slug) {
  const normalized = normalizeWorkspaceSlug(slug);
  if (!normalized) return path;
  const raw = String(path || "").trim() || "/";
  const [pathname, query = ""] = raw.split("?");
  const params = new URLSearchParams(query);
  params.set("ws", normalized);
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
}

/**
 * Preserva/anexa `?ws=` do workspace ativo nesta aba (master/partner em atendimento).
 * Sem slug ativo, devolve o path intacto.
 */
export function withActiveWorkspaceQuery(path) {
  return appendWorkspaceQuery(path, getActiveWorkspaceSlug());
}
